<template>
  <div>
    <div style="padding: 0px 10px 15px 10px">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="left"
        label-width="80px"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_lable_locationCode') || '库位号'"
              prop="locationCode"
            >
              <el-cascader
                :options="treeData"
                :props="{
                  emitPath: false,
                  checkStrictly: true,
                  value: 'code',
                  label: 'label',
                }"
                size="small"
                ref="cascaderFunctionTreeRef"
                v-model="form.locationCode"
                @change="calculateClassLevel"
                clearable
                style="width: 100%"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isSingle">
            <el-form-item
              :label="$l('form_lable_fabricCardBarcode') || '面料条码'"
              prop="fabricCardBarcode"
            >
              <el-input
                v-model="form.fabricCardBarcode"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="100"
                clearable
                size="small"
                style="width: 100%"
                @change="getFabricInfo"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <FabricTable
      :tableData="tableData"
      :isSingle="isSingle"
      @delRow="delRow"
    ></FabricTable>

    <div class="d-flex justify-content-end mt-2 mb-2">
      <el-button type="primary" size="small" @click="shelve()">
        {{ $l('btn_shelve') || '上架' }}
      </el-button>
    </div>
  </div>
</template>
<script>
import FabricTable from './fabric-table'
import validate from '@/libs/util.validate'
export default {
  components: { FabricTable },
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
    dataList: { type: Array, default: () => [] },
    isSingle: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      form: {
        locationNo: '',
        locationCode: '',
        level: 0,
        fabricCardBarcode: '',
      },
      rules: {
        locationCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    fabricCardBarcodeList() {
      return this.tableData.map((e) => e.fabricCardBarcode) || []
    },
  },
  watch: {
    dataList: {
      handler() {
        if (this.dataList && this.dataList.length > 0) {
          this.tableData = this.tableData.concat(...this.dataList)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async shelve() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      if (this.form.level == '0') {
        this.$message.warning(
          this.$l('dialog_confirm_msg') || '不可将顶级展厅设置为库位！',
        )
        return
      }
      if (
        !this.fabricCardBarcodeList ||
        this.fabricCardBarcodeList.length == 0
      ) {
        this.$message.warning(
          this.$l('dialog_fabricInformation_cannot_be_empty') ||
            '面料信息不能为空！',
        )
        return
      }
      this.$api
        .fabricCardchangeLocationApi({
          locationNo: this.form.locationNo,
          fabricCardBarcodeList: this.fabricCardBarcodeList,
        })
        .then(() => {
          this.$message.success(this.$l('INDEX.tips_set_ok') || '设置成功！')
          this.$emit('close')
        })
    },
    calculateClassLevel() {
      const node = this.$refs.cascaderFunctionTreeRef.getCheckedNodes()
      if (node && node.length) {
        this.form.locationNo = node[0].data.locationNo
        this.form.level = node[0].data.level
      }
    },
    getFabricInfo() {
      let code = this.form.fabricCardBarcode
      if (!code) return
      if (code.startsWith('FB_')) {
        const parts = code.split('_')
        if (parts.length > 2) {
          code = parts[2]
        }
      }
      if (
        this.fabricCardBarcodeList &&
        this.fabricCardBarcodeList.includes(code)
      ) {
        this.form.fabricCardBarcode = ''
        return
      }
      this.$api
        .fabricCardDetailBarcodeApi({
          fabricCardBarcode: code,
        })
        .then((res) => {
          this.tableData = this.tableData.concat(res.body?.data || [])
          this.form.fabricCardBarcode = ''
        })
        .catch(() => {
          this.form.fabricCardBarcode = ''
        })
    },
    delRow(rowId) {
      this.tableData.splice(rowId, 1)
    },
  },
}
</script>
